function readMore() {
  // footer text
  if (document.getElementsByClassName('view-more-button')[0]) {
    var moreText = document.getElementsByClassName('view-more-text')[0];
    var viewMoreButton = document.getElementsByClassName('view-more-button')[0];

    viewMoreButton.onclick = function(e) {
      if (!viewMoreButton.classList.contains('opened')) {
        moreText.style.maxHeight = '3000px';
        viewMoreButton.classList.add('opened');
      }
      else {
        moreText.style.maxHeight = '0px';
        setTimeout(function() {
          viewMoreButton.classList.remove('opened');
        }, 300);
      }
    };
  }

  // reference paragraph
  if (document.getElementsByClassName(
      'field--name-field-reference-button')[0]) {
    var referencesButton = document.getElementsByClassName(
        'field--name-field-reference-button')[0];
    var hiddenContainer = document.querySelectorAll('.paragraph--type--abbreviations-references > .container > .field--name-field-content')[0];

    referencesButton.onclick = function(e) {
      if (hiddenContainer) {
        if (!referencesButton.classList.contains('opened')) {
          hiddenContainer.style.maxHeight = '3000px';
          referencesButton.classList.add('opened');
        }
        else {
          hiddenContainer.style.maxHeight = '0px';
          referencesButton.classList.remove('opened');
        }
      }
    };
  }

  //under reference text
  if (document.getElementsByClassName(
    'open-box')[0]) {
    var openboxButton = document.getElementsByClassName(
      'open-box')[0];
    var hiddenContent = document.getElementsByClassName(
      'box-content')[0];

    openboxButton.onclick = function(e) {
      if (hiddenContent) {
        if (!openboxButton.classList.contains('opened')) {
          hiddenContent.style.maxHeight = '3000px';
          openboxButton.classList.add('opened');
        }
        else {
          hiddenContent.style.maxHeight = '0px';
          openboxButton.classList.remove('opened');
        }
      }
    };
  }

  //under reference text
  if (document.getElementsByClassName(
    'open-box-top')[0]) {
    var openboxButtonTop = document.getElementsByClassName(
      'open-box-top')[0];
    var hiddenContentTop = document.getElementsByClassName(
      'box-content-top')[0];

    openboxButtonTop.onclick = function(e) {
      if (hiddenContentTop) {
        if (!openboxButtonTop.classList.contains('opened')) {
          hiddenContentTop.style.maxHeight = '3000px';
          openboxButtonTop.classList.add('opened');
        }
        else {
          hiddenContentTop.style.maxHeight = '0px';
          openboxButtonTop.classList.remove('opened');
        }
      }
    };
  }
}
